import {
  BeamBreakIcon,
  BpeAdaptorIcon,
  DistanceSensorIcon,
  HighSpeedMotorIcon,
  HighTorqueMotorIcon,
  MagneticSensorIcon,
} from '../Components/Icons/Bits';
import { electronics } from './constants';

type BitsElectronicIcon = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;

const BITS_ELECTRONIC_ICON_BY_TYPE: Record<string, BitsElectronicIcon> = {
  [electronics.distanceSensor.ELECTRONIC_TYPE]: DistanceSensorIcon,
  [electronics.highSpeedMotor.ELECTRONIC_TYPE]: HighSpeedMotorIcon,
  [electronics.highTorqueMotor.ELECTRONIC_TYPE]: HighTorqueMotorIcon,
  [electronics.beamBreakSensor.ELECTRONIC_TYPE]: BeamBreakIcon,
  [electronics.magneticSwitch.ELECTRONIC_TYPE]: MagneticSensorIcon,
  [electronics.BPEadaptor.ELECTRONIC_TYPE]: BpeAdaptorIcon,
};

export const getBitsElectronicIcon = (electronicType: string | null | undefined): BitsElectronicIcon | null => {
  if (!electronicType) {
    return null;
  }

  return BITS_ELECTRONIC_ICON_BY_TYPE[electronicType] ?? null;
};
